import { useMemo } from 'react';
import ControlledInput from '../../components/ControlledInput';
import * as React from 'react';

import ControlledMultiDropdown from '../../components/ControlledMultiDropdown';
import BtnFilled from '../../components/BtnFilled';
import { useDevicesStore } from '../../stores';
import Accordion from '../../components/Accordion';
import { FormProvider, useForm } from 'react-hook-form';

const CreateForm = ({ handleSubmit }) => {
  const methods = useForm({ mode: 'onChange' });

  const { devices } = useDevicesStore();

  const options = useMemo(() => {
    return devices.map((item) => ({
      label: item.serial_number,
      value: item.id,
    }));
  }, [devices]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Accordion id={'create'} initialValue={{ create: true }} name={'Создание группы'}>
          <ControlledInput
            rules={{ required: 'Введите название группы' }}
            classContainer={'mb-4'}
            name={'description'}
            label={'Название группы'}
            placeholder={'Введите название группы устройств'}
          />
          <ControlledMultiDropdown
            name="ids"
            label={'Список устройств'}
            placeholder={'Выберите устройства'}
            rules={{ required: 'Выберите хотя бы одно устройство' }}
            options={options}
          />
          <BtnFilled disabled={!methods.formState.isValid || methods.formState.isSubmitting} className="max-w-[240px] mt-6" title="Создать" type={'submit'} />
        </Accordion>
      </form>
    </FormProvider>
  );
};
export default CreateForm;
